import { AxiosResponse } from "axios";
import { call, CallEffect, PutEffect } from "@redux-saga/core/effects";
import { PlateData } from "./getData";
import { Action } from "redux-saga";
import { clearString } from "@/utils/functions";
import { automaticApi } from "@/settings/api";

export interface Fetch {
  plate: string;
  document: string;
  pin?: string;
  hashCode?: string;
  callback: (
    success: boolean,
    data?:
      | {
          hash?: string;
          plateData?: PlateData;
        }
      | string,
  ) => void;
}

export interface ValidatePlateAction {
  type: string;
  payload: Fetch;
}

const uri = "/pedido/v1/validarplaca";

export default function* validatePlate({
  payload,
}: ValidatePlateAction): Generator<
  CallEffect<unknown> | PutEffect<Action>,
  void,
  AxiosResponse
> {
  try {
    const body: {
      cpfCnpj: string;
      placa: string;
      pin?: string;
      hashPin?: string;
    } = {
      cpfCnpj: clearString(payload?.document),
      placa: clearString(payload?.plate).toUpperCase(),
      pin: payload?.pin,
      hashPin: payload?.hashCode,
    };
    const response = yield call(automaticApi.post, uri, body);
    const data = response?.data;
    if (data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true, data?.dados?.hash);
    } else {
      yield call(
        payload.callback,
        false,
        !data?.dados?.isValid ? "already" : "timeout",
      );
    }
  } catch (error) {
    yield call(payload.callback, false, "timeout");
  }
}
